module.exports = __webpack_public_path__ + "assets/img/31t.0a0cf986.png";